import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
export default function isNullOrUndefined(value) {
  return isNull(value) || isUndefined(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/isNullOrUndefined.js
// module id = 1032
// module chunks = 33